<div class="is-flex is-align-items-center is-justify-content-center is-flex-direction-column h-100">
  <p class="has-text-centered" i18n>Forbidden: You don't have permission to access this address.</p>
</div>

